/* React hooks */
import {useEffect, useState} from "react";
/* Components */
import useAuth from "../../../hooks/useAuth";
import FormFunerariumAddress from "../../../forms/funerarium/FormFunerariumAddress";
import useData from "../../../hooks/useData";
import {getCountryList} from "../../../api/admin/addressReq";
import Icon from "../../../components/common/Icon";


export default function ViewFunerariumAddress({ apiFunerariumGeneralInfos }) {
    const { auth } = useAuth();
    const token = auth.token;
    const { funerariumInfos } = useData();
    const [ showModal, setShowModal ] = useState(false);
    const { countryList, setCountryList } = useData();

    const apiCountryList = async () => {
        const response = await getCountryList(token);
        setCountryList(response);
    }

    const selectedCountry = countryList?.find(country => country.code === funerariumInfos?.address?.country)?.name;

    useEffect(() => {
        apiCountryList();
    }, [ token]);

    const handleFormFunerariumAddress = () => {
        setShowModal(true);
    }


    return (
        <fieldset>
            { showModal &&
                <div className="modal funerarium-address">
                    <FormFunerariumAddress apiFunerariumGeneralInfos={apiFunerariumGeneralInfos} setShowModal={setShowModal} legend="Modification des coordonnées du funérarium"/>
                </div>
            }

            <Icon span="Adresse du funérarium" source="fa fa-location-dot" />
            <div className="form-input">
                <label htmlFor="address">Adresse</label>
                <span>{funerariumInfos?.address?.address}</span>
            </div>
            <div className="form-input">
                <label htmlFor="addressComp">Complément d'adresse</label>
                <span>{funerariumInfos?.address?.addressComp}</span>
            </div>
            <div className="form-input">
                <label htmlFor="postal_code">Code postal</label>
                <span>{funerariumInfos?.address?.zipcode}</span>
            </div>
            <div className="form-input">
                <label htmlFor="city">Ville</label>
                <span>{funerariumInfos?.address?.city}</span>
            </div>
            <div className="form-input">
                <label htmlFor="country">Pays</label>
                <span>{selectedCountry}</span>
            </div>
            <div className="buttons-container">
                <button type="button" className="red-button" onClick={handleFormFunerariumAddress}>
                    <i className="fa fa-pen"/><span>Modifier les informations</span>
                </button>
            </div>
        </fieldset>
    )
}